import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {getAuth, GoogleAuthProvider, signInWithPopup, signOut, User} from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyAHjNQW839wAFSsasvoGPE9C9NKIqPXd88",
    authDomain: "pain-management-2025.firebaseapp.com",
    projectId: "pain-management-2025",
    storageBucket: "pain-management-2025.appspot.com", // Diperbaiki dari "firebasestorage.app"
    messagingSenderId: "350303959885",
    appId: "1:350303959885:web:3860c58e09dd84348ed504",
    measurementId: "G-2TZW4CE5D0",
};

// Inisialisasi Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
export const provider = new GoogleAuthProvider();

// Fungsi untuk login dengan Google
const signInWithGoogle = async (): Promise<User | null> => {
    try {
        const result = await signInWithPopup(auth, provider);
        console.log("User Info:", result.user);
        return result.user; // Mengembalikan data user
    } catch (error) {
        console.error("Error during sign-in:", error);
        return null;
    }
};

// Fungsi untuk logout
const logOut = async (): Promise<void> => {
    try {
        await signOut(auth);
        console.log("User logged out");
    } catch (error) {
        console.error("Error during logout:", error);
    }
};

export { db, auth, signInWithGoogle, logOut };
